import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import ComposerState from 'flarum/forum/states/ComposerState';
import Composer from 'flarum/forum/components/Composer';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import ReplyComposer from 'flarum/forum/components/ReplyComposer';
import EditPostComposer from 'flarum/forum/components/EditPostComposer';
import Button from 'flarum/common/components/Button';
import SchedulePostModal from './components/SchedulePostModal';
// @ts-ignore - no types available for lodash.result
import result from 'lodash.result';
import { slug } from '../common';
import ItemList from 'flarum/common/utils/ItemList';
import type Mithril from 'mithril';

// Extend the Composer component to include our custom method
// @ts-ignore - Extending Composer with custom method
Composer.prototype.schedulePost = function () {};

export default function addDiscussionComposerItem() {
	extend(ComposerState.prototype, 'load', function (this: ComposerState, _, __, attrs: any) {
		// Re-initialize the scheduling attributes
		// (Always ! else users might make other posts scheduled without intending to...)
		delete this.isScheduled;
		delete this.scheduledAt;

		if (this.bodyMatches(DiscussionComposer)) {
			this.scheduledAt = undefined;
			this.isScheduled = false;
		}
		if (this.bodyMatches(EditPostComposer)) {
			// Only if editing the first post
			if (result(attrs, 'post.number', false) === 1) {
				this.scheduledAt = result(attrs, 'post.discussion.scheduledAt', undefined);
				this.isScheduled = this.scheduledAt ? !!this.scheduledAt : undefined;
			}
		}
	});

	// Method that shows a modal where the user can schedule a post
	(Composer.prototype as any).schedulePost = function (this: Composer) {
		// Show a modal to edit the scheduling of the post.
		// On submitting this modal's input, we update (or create)
		// attributes of the Composer's state.
		app.modal.show(SchedulePostModal, {
			scheduledAt: this.state?.scheduledAt,
			isScheduled: this.state?.isScheduled,
			onsubmit: (scheduledAt: Date, isScheduled: boolean) => {
				if (this.state) {
					this.state.scheduledAt = scheduledAt;
					this.state.isScheduled = isScheduled;
				}
			},
		});
	};

	// Add a button that opens the modal for scheduling a post
	extend(Composer.prototype, 'controlItems', function (this: Composer, items: ItemList<Mithril.Children>) {
		if (!result(app, 'session.user.canSchedulePosts', false)) {
			// if the user isn't allowed to schedule posts, he should not see this button,
			// so do nothing
			return;
		}

		// Prevent scheduling button from being rendered when replying
		if (app.composer.bodyMatches(ReplyComposer)) {
			return;
		}

		// Determine if the current post is scheduled or not
		let isScheduled = this.state?.isScheduled;

		// If we are editing a post from a discussion that isn't scheduled, do nothing
		if (result(this, 'state.body.attrs.post.number', -1) > 1) {
			return;
		}
		if (isScheduled === undefined) {
			isScheduled = !!result(this, 'state.body.attrs.post.discussion.scheduledAt', false);
			if (!isScheduled) {
				return;
			}
		}

		items.add(
			'schedule-post',
			<Button
				icon="fas fa-clock"
				className={`Button Button--icon Button--link ${isScheduled ? 'active' : ''}`}
				title={app.translator.trans(`${slug}.forum.composer.schedule_post_title`)}
				onclick={(this as any).schedulePost.bind(this)}
			/>,
			20
		);
	});

	// Add the scheduledAt attribute the the data of a created discussion or an edited post
	// or the unschedule attribute if we need to unschedule the post and make it public right away.
	function onData(this: any, data: any) {
		const { isScheduled, scheduledAt } = this.composer;
		if (isScheduled) {
			data.scheduledAt = scheduledAt;
		} else if (app.composer.bodyMatches(EditPostComposer) && isScheduled === false) {
			data.unschedule = true;
		}
	}

	extend(DiscussionComposer.prototype, 'data', onData);
	extend(EditPostComposer.prototype, 'data', onData);
}
